import * as React from 'react';
import SVG from 'react-inlinesvg';
import Modal from 'react-bootstrap/Modal';
import { dispatch, state } from '__common/store';
import Button from 'react-md/lib/Buttons/Button';
import { HIDE_MODAL_FOR_OS_REPORTS, SEND_BOM_DATA_TO_OS, SET_OS_LOADER } from 'actions';
import { connect } from 'react-redux';
import { getFileNamePrefix } from 'engineering/components/engineeringProjectDocuments/utils/reportsApi';
import { getProductName } from '__common/constants/products';


type Props = {
    bom: bomState,
    showModal: boolean,
};

export default class ModalForOsomReport extends React.Component<Props, {}> { 
    osReportCancel() {
        dispatch(HIDE_MODAL_FOR_OS_REPORTS());
        }
    retrySendBomData() {
        const {projectConfiguration:{projectId}} = state();
        dispatch(SEND_BOM_DATA_TO_OS(projectId));
        dispatch(SET_OS_LOADER());
      }
    downloadOsBom = async (e) => {
        e.preventDefault();
        const {projectConfiguration:{ projectId, productId } } = state();
        const filename = `${getFileNamePrefix(getProductName(productId), projectId)}_BOM_report_for_os.pdf`;
        // If we already have a blob URL from the epic success, use it directly
        const prebuiltUrl = this.props?.bom?.osReport?.osReportsDataUrl;
        if (prebuiltUrl) {
            const link = document.createElement('a');
            link.href = prebuiltUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            return;
        }
        try {
            const urlBase = `/api/v1/bom/send_bom_data_to_opensolar/${projectId}/`;
            const res = await fetch(`${urlBase}?t=${Date.now()}`, { credentials: 'include' , headers: { 'Accept': 'application/pdf' }});
            const contentType = (res.headers.get('content-type') || '').toLowerCase();
            if (res.ok && contentType.includes('application/pdf')) {
                const blob = await res.blob();
                if (blob && blob.size > 0) {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                    return;
                }
            }
            if (res.status === 422 && contentType.includes('application/json')) {
                const json = await res.json();
                if (json && json.file) {
                    const byteCharacters = atob(json.file);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) byteNumbers[i] = byteCharacters.charCodeAt(i);
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                    return;
                }
            }
            // As a fallback (CORS/cookie issues), trigger download via hidden iframe without opening a tab
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = `${urlBase}?t=${Date.now()}`;
            document.body.appendChild(iframe);
            setTimeout(() => { try { document.body.removeChild(iframe); } catch(_){} }, 10000);
        } catch (_) {}
    }
 render() {
    const {projectConfiguration:{ projectId, productId } } = state();
    const {bom:{osReport}} = this.props;
    const isError = osReport?.error;
    const isLoading = osReport?.loading;
    return (
        <>
            <Modal show={this.props.showModal} size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered dialogClassName="modal-90w custom-modal-for-aurora-bom"
            >
                <Modal.Header>
                    <h2 className="aurora-modal-heading">Send U-Builder Data to Open Solar</h2>
                    {!isLoading && (<img className='close-btn-aurora-bom' onClick={this.osReportCancel} src={require('assets/media/icons/Icon material-cancel.png')}/>)}
                </Modal.Header>
                
                <Modal.Body >
                {isLoading ? (
                    <>
                        <div className="modal-body-for-aurora loading">
                            <div className="opensolar-loading"></div>
                            <p className='aurora-loading-message'>Configuring Your Options For Better Solar</p>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="modal-body-for-aurora">
                            <div className="aurora-download-bom">
                                <img src={require("assets/media/icons/image_beside_download_button.png")} height={181} width={189}/>
                                <Button className="aurora-reports-download-button">
                                    <a href="#" className='aurora-reports-download-button-link' onClick={this.downloadOsBom}>
                                        <img className="download-icon" src={require("assets/media/icons/Icon-feather-download.png")} height={17} width={17}/>
                                        DOWNLOAD BOM
                                    </a>
                                </Button> 
                            </div>
                            <hr/>
                            {!isError ? (
                                <>
                                   
                                    <div className="aurora-successful">
                                        <img className="success-icon" src={require("assets/media/icons/verified_icon.png")} height={64} width={64}/>
                                        <p className="successfully-integrated-aurora">Successfully Sent</p>
                                        <p className="successfully-integrated-aurora-paragraph">Your data to Open Solar from U-Builder <br/> has been successfully exported.</p>
                                    </div>
                                </>
                                
                            ): (
                                <div className="aurora-failure">
                                    <img className="failure-icon" src={require("assets/media/icons/image_beside_retry_send_bom.png")} height={156} width={185}/>
                                    <div className="integration-failure-content">
                                        <p className="integration-failure-aurora">Unable To Connect With Open Solar</p>
                                        <p className="integration-failure-aurora-paragraph">Your data connection to Open Solar from U-Builder <br/> faced some error. Please Try Again.</p>
                                        <Button className="aurora-reports-retry-button">
                                            <a href="#" className="aurora-reports-retry-button-link" onClick={this.retrySendBomData}>
                                            <img className="retry-icon" src={require("assets/media/icons/Icon-feather-refresh-ccw.png")} height={17} width={17}/>
                                                Retry Connection
                                            </a>
                                        </Button>
                                    </div>
                                    
                                </div>
                            )}
                            
                        </div>
                    </>
                    
                )}
                
                </Modal.Body>
            </Modal>
        </>
      )
    }
}
